import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import SupabaseStatus from './SupabaseStatus';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiList, FiSettings, FiLogOut } = FiIcons;

const Header = ({ onLock }) => {
  const location = useLocation();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to lock the application?')) {
      onLock();
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center space-x-2 text-blue-600 hover:text-blue-700">
              <h1 className="text-2xl font-bold">Prosomo SEO Writer</h1>
            </Link>
            <SupabaseStatus />
          </div>
          
          <div className="flex items-center space-x-4">
            <nav className="flex items-center space-x-6">
              <Link 
                to="/" 
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                  location.pathname === '/' 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <SafeIcon icon={FiList} className="text-lg" />
                <span>Articles</span>
              </Link>
              
              <Link 
                to="/editor" 
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                  location.pathname.includes('/editor') 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <SafeIcon icon={FiEdit3} className="text-lg" />
                <span>New Article</span>
              </Link>
              
              <Link 
                to="/settings" 
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                  location.pathname === '/settings' 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <SafeIcon icon={FiSettings} className="text-lg" />
                <span>Settings</span>
              </Link>
            </nav>
            
            <button 
              onClick={handleLogout}
              className="flex items-center space-x-2 px-4 py-2 text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
              title="Lock Application"
            >
              <SafeIcon icon={FiLogOut} className="text-lg" />
              <span>Lock</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;